import { EChartsOption } from 'echarts';

export type KtChartDisplayItem = {
  key: string;
  label: string;
  description: string;
};

export const KT_CHART_DISPLAY_ITEMS: KtChartDisplayItem[] = [
  {
    key: 'KTAppetite',
    label: '①食べる意欲',
    description:
      '1 促しや援助しても食べようとしない\r\n 2 促しや援助で少し食べる\r\n 3 促しや援助で半量食べる\r\n 4 促しや援助でほとんど食べる\r\n 5 介助の有無に関わらず食べようとする，食べたいと意思表示する',
  },
  {
    key: 'KTWholeBody',
    label: '②全身状態',
    description:
      '1 （全般）発熱があり, 意識レベルは不良\r\n 2 （急性期）何らかの急性疾患による発熱はあるが37.5 ℃以下に解熱するときがある。もしくは意識レベルが概ね良好\r\n （回復期・生活期）発熱があり，たびたび治療が必要となる\r\n 3 （急性期）3日以上37.5 ℃以下で意識状態が概ね良好\r\n （回復期・生活期）1カ月に1-2回37.5 ℃以上の発熱があり，治療を要することがある\r\n 4 （急性期）7日以上発熱はなく，意識レベルは概ね良好\r\n （回復期・生活期）1カ月に1-2回37.5 ℃以上の発熱があるが，とくに治療をしなくても解熱する\r\n 5 発熱はなく，意識レベルは良好',
  },
  {
    key: 'KTBreathing',
    label: '③呼吸状態',
    description:
      '1 絶えず痰貯留があり，1日10回以上の吸引が必要\r\n 2 痰貯留があり，1日5-9回の吸引が必要\r\n 3 痰貯留があり，1日5回未満の吸引が必要\r\n 4 痰貯留があるが，自力で喀出が可能\r\n 5 痰貯留や湿性嗄声がない\r\n  ※気管カニューレがある場合，-1 点とする',
  },
  {
    key: 'KTOral',
    label: '④口腔状態',
    description:
      '1 口腔衛生が著しく不良で，歯や義歯に歯科治療が必要\r\n 2 口腔衛生が不良で，歯や義歯に歯科治療が必要\r\n 3 口腔衛生は改善しているが，歯や義歯の治療は必要\r\n 4 口腔衛生は良好だが，歯や義歯の治療は必要\r\n 5 口腔衛生は良好で，歯や義歯の治療は必要としない',
  },
  {
    key: 'KTCognition',
    label: '⑤認知機能（食事中）',
    description:
      '1 食事中の認知機能が著しく低く，覚醒レベルも低く，全介助が必要\r\n 2 食事中の認知機能が低く，全介助が必要\r\n  3 食事中の認知機能が低く，一部介助が必要\r\n 4 食事中の認知機能は概ね保たれているが，介助を必要とすることがある\r\n 5 食事中の認知機能は良好で，介助なしで食事摂取可能',
  },
  {
    key: 'KTMastication',
    label: '⑥咀嚼・送り込み',
    description:
      '1 食べるための口・舌・頬・あごの動きのすべてがかなり困難\r\n 2 食べるための口・舌・頬・あごの動きのいずれかがかなり困難\r\n 3 食べるための口・舌・頬・あごの動きのいずれかが困難だが，何らかの対処法で対応できる\r\n 4 食べるための口・舌・頬・あごの動きのいずれも概ね良好\r\n 5 食べるための口・舌・頬・あごの動きのすべてが良好',
  },
  {
    key: 'KTSwallowing',
    label: '⑦嚥下',
    description:
      '1 嚥下できない，頻回のむせ，呼吸促迫，重度の誤嚥\r\n 2 嚥下は可能だが，むせや咽頭残留，呼吸変化を伴う\r\n 3 嚥下は可能だが，むせ・咽頭残留・複数回嚥下・湿性嗄声のいずれかを伴うが，呼吸変化はなし\r\n 4 嚥下可能で，むせはない，咽頭残留はあるかもしれないが，処理可能，良好な呼吸\r\n 5 嚥下可能で，むせ・咽頭残留はなく，良好な呼吸',
  },
  {
    key: 'KTPosture',
    label: '⑧姿勢・耐久性',
    description:
      '1 ベッド上で食事の姿勢保持が困難，あるいはベッド上ですべての食事をしている\r\n 2 リクライニング車いすで食事の姿勢保持が困難で，かなりの介助が必要\r\n 3 介助によりリクライニング車いすで食事の姿勢保持が可能\r\n 4 介助により普通型車いすで食事の姿勢保持が可能\r\n 5 介助なしで普通の椅子で食事の姿勢保持が可能',
  },
  {
    key: 'KTEatingBehavior',
    label: '⑨食事動作',
    description:
      '1 すべての食物を皿から自分の口に運び，咀嚼嚥下する食事動作に相当の介助が必要。自力では食事動作の25% 未満しかできない，あるいは経管栄養\r\n  2 介助が必要。自力で食事動作の25％以上50％未満を行う\r\n 3 一部介助が必要。自力で食事動作の50％以上を行う\r\n 4 食事動作に間接的な介助のみ（準備や見守り）が必要で，自立している。（食事時間が長くかかる症例も含める）\r\n 5 食事動作が完全に自立している。（自助具を使用する場合も含む）',
  },
  {
    key: 'KTADL',
    label: '⑩活動',
    description:
      '1 寝たきり，ベッドからの移乗・トイレ・食事・更衣などすべてに介助が必要\r\n 2 介助で車いすへの移乗が可能で，ベッドから離れて食事が可能だが，めったに外出はしない\r\n 3 介助で車いすへの移乗が可能で，ベッドから離れて食事が可能。さらに介助でよく外出する\r\n 4 自力で車いすへの移乗が可能で，ベッドから離れて食事が可能だが，めったに外出はしない\r\n 5 自力で車いすへの移乗が可能で，ベッドから離れて食事が可能。1人で外出が可能，あるいは介助でよく外出する',
  },
  {
    key: 'KTOralIntake',
    label: '⑪摂食状況レベル',
    description:
      '1 人工栄養のみ，もしくは間接嚥下訓練のみ\r\n 2 少量の経口摂取は可能（直接嚥下訓練含む）だが，主に人工栄養に依存\r\n 3 半分以上が経口摂取で，補助的に人工栄養を使用\r\n 4 形態を変えた食事や飲料を経口摂取，人工栄養は使用しない\r\n 5 形態を変えずに食事や飲料を経口摂取，人工栄養は使用しない',
  },
  {
    key: 'KTFoods',
    label: '⑫食物形態',
    description:
      '1 口からは何も食べていない\r\n 2 ゼリーやムース食を主に食べる\r\n 3 ペースト食を主に食べる\r\n 4 咀嚼食を主に食べる\r\n 5 普通食を主に食べる',
  },
  {
    key: 'KTNutrition',
    label: '⑬栄養',
    description:
      '1 栄養状態がとても悪い\r\n 2 栄養状態が悪い\r\n 3 栄養状態が悪くない\r\n 4 栄養状態が良い\r\n 5 栄養状態がとても良い',
  },
];

const formatRadarIndicatorLabel = (label: string): string => {
  if (label.includes('摂食状況レベル')) {
    return label.replace('摂食状況レベル', '摂食状況\nレベル');
  }
  if (label.includes('認知機能（食事中）')) {
    return label.replace('認知機能（食事中）', '認知機能\n（食事中）');
  }
  return label;
};

export const KT_CHART_RADAR_ORDER = [
  0, // ①食べる意欲
  12, // ⑬栄養
  11, // ⑫食物形態
  10, // ⑪摂食状況レベル
  9, // ⑩活動
  8, // ⑨食事動作
  7, // ⑧姿勢・耐久性
  6, // ⑦嚥下
  5, // ⑥咀嚼・送り込み
  4, // ⑤認知機能（食事中）
  3, // ④口腔状態
  2, // ③呼吸状態
  1, // ②全身状態
];

export type KtChartSizing = {
  fontSize: number;
  radarRadius: string;
  pieInnerRadius: string;
  pieOuterRadius: string;
};

export const calculateKtChartSizing = (
  screenWidth: number,
  chartWidth: number,
): KtChartSizing => {
  if (screenWidth <= 849) {
    if (chartWidth <= 300) {
      return {
        fontSize: 7,
        radarRadius: '55%',
        pieInnerRadius: '50%',
        pieOuterRadius: '60%',
      };
    }
    return {
      fontSize: 11,
      radarRadius: '65%',
      pieInnerRadius: '60%',
      pieOuterRadius: '70%',
    };
  }
  if (chartWidth <= 300) {
    return {
      fontSize: 8,
      radarRadius: '50%',
      pieInnerRadius: '45%',
      pieOuterRadius: '55%',
    };
  }
  if (chartWidth <= 500) {
    return {
      fontSize: 11,
      radarRadius: '67%',
      pieInnerRadius: '60%',
      pieOuterRadius: '70%',
    };
  }
  return {
    fontSize: 12,
    radarRadius: '70%',
    pieInnerRadius: '60%',
    pieOuterRadius: '70%',
  };
};
export const buildKtChartValues = (
  resolver: (key: string) => number | string | null | undefined,
): number[] =>
  KT_CHART_RADAR_ORDER.map(index => {
    const raw = resolver(KT_CHART_DISPLAY_ITEMS[index].key);
    const numeric = Number(raw);
    return Number.isFinite(numeric) ? numeric : 0;
  });

export const createKtChartBaseOption = (options?: { fontSize?: number; radarRadius?: string; pieInnerRadius?: string; pieOuterRadius?: string }): EChartsOption => ({
  textStyle: {
    color: 'rgba(60,60,60,0.8)',
    fontSize: options?.fontSize ?? 10.5,
  },
  radar: {
    shape: 'circle',
    radius: options?.radarRadius ?? '70%',
    indicator: KT_CHART_RADAR_ORDER.map(index => ({
      name: formatRadarIndicatorLabel(KT_CHART_DISPLAY_ITEMS[index].label).replace(/\r?\n/g, '\n'),
      max: 5,
      min: 0,
      color: 'rgba(60,60,60,1)',
      formatter: value => value,
    })),
    axisNameGap: 24,
    axisName: {
      color: 'rgba(60,60,60,1)',
      fontSize: (options?.fontSize ?? 10.5) * 0.9,
      overflow: 'truncate',
      width: 120,
    },
    splitArea: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: '#bbb',
      },
    },
  },
  series: [
    {
      type: 'radar',
      symbol: 'circle',
      symbolSize: 4,
      lineStyle: {
        color: 'rgba(255,0,0,0.6)',
        width: 2,
      },
      itemStyle: {
        color: 'rgba(255,0,0,0.9)',
      },
      areaStyle: {
        opacity: 0,
      },
      data: [
        {
          value: new Array(KT_CHART_RADAR_ORDER.length).fill(0),
        },
      ],
    },
    {
      type: 'pie',
      color: [
        'rgba(255,0,0,0.2)',
        'rgba(255,165,0,0.2)',
        'rgba(0,153,0,0.2)',
        'rgba(153,0,153,0.2)',
        'rgba(255,0,0,0.2)',
      ],
      radius: [options?.pieInnerRadius ?? '60%', options?.pieOuterRadius ?? '70%'],
      labelLine: {
        show: false,
      },
      label: {
        show: false,
      },
      data: [
        { value: 96.915 },
        { value: 83.07 },
        { value: 83.07 },
        { value: 83.07 },
        { value: 13.845 },
      ],
      emphasis: {
        scale: false,
      },
      animationDuration: 0,
    },
  ],
});

export const buildKtChartMergeOption = (
  values: number[],
): Pick<EChartsOption, 'series'> => ({
  series: [
    {
      data: [
        {
          value: values,
        },
      ],
    },
  ],
});
